import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Grid,
  Tooltip,
  Typography,
  DialogActions,
  Button,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { SelectResult } from '../../../../components/select/select-chain.component';

import { useSaveData } from '../../../../hooks/useSaveData';
import { workOrdersApiKeyStore } from '../../../../api/workorders-api-key-store';
import { useState } from 'react';
import { ServiceList } from './service-list-for-switch-service';
import { useAuthorize } from '../../../../hooks/use-authorize';
import { UserPermissionName } from '../../../../models/user-permission-name';

const styling = {
  dialogTitleStyle: { padding: '16px 24px 0' },
  contentPadding: { paddingTop: '30px' },
  buttonPadding: { paddingTop: '20px' },
  tabHeading: { fontWeight: 'bold' },
  buttonStyle: { width: '130px' },
};

interface CreateWorkorderDialogProps {
  open: boolean;
  onClose: () => void;
  refetch?: () => void;
  unitID?: number;
  workOrderID?: number;
  selectedServiceID: number;
  onHandleSetSelectedServiceId: (value: number) => void;
}

export const SelectServiceDialog = ({
  open,
  onClose,
  refetch,
  unitID,
  workOrderID,
  selectedServiceID,
  onHandleSetSelectedServiceId,
}: CreateWorkorderDialogProps) => {
  // const [selectedServiceID, setSelectedServiceID] = useState<number>(0);
  const handleDialogClose = () => {
    onClose();
  };
  const { isLoading: isSaving, mutateAsync } = useSaveData(workOrdersApiKeyStore.switchService());

  const handleSaveClick = async () => {
    await mutateAsync({
      data: { workOrderID: workOrderID, serviceID: selectedServiceID },
    });
    refetch?.();
    handleDialogClose();
  };

  const handleSetSelectedServiceId = (value: number) => {
    onHandleSetSelectedServiceId(value);
  };

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={'sm'}
      onClose={handleDialogClose}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
    >
      <DialogTitle id="dialog-title" style={styling.dialogTitleStyle}>
        Switch Service
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleDialogClose}
        sx={{
          position: 'absolute',
          right: 10,
          top: 3,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers style={styling.contentPadding} className="popupDilog selectServiceList">
        <ServiceList
          name="serviceData"
          unitID={unitID}
          handleSetSelectedServiceId={handleSetSelectedServiceId}
          workOrderID={workOrderID}
        />
      </DialogContent>
      <div style={{ padding: '5px', paddingLeft: '16px', paddingRight: '16px' }}>
        <DialogActions className="spaceBetween">
          <Button variant="outlined" style={{ width: '130px' }} onClick={handleDialogClose}>
            Cancel
          </Button>
          <Button
            type={'button'}
            variant="contained"
            disableElevation={true}
            style={styling.buttonStyle}
            disabled={isSaving || !selectedServiceID || isReadOnlyPermission}
            onClick={handleSaveClick}
          >
            Save
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};
